import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import { Trans, useTranslation } from 'react-i18next'
import { Icon } from '#app/components/ui/icon'

export const meta: MetaFunction = () => {
	return [{ title: 'Terms and Conditions | OneCare' }]
}

export default function PrivacyRoute() {
	let { t } = useTranslation('common')

	return (
		<div className="relative isolate flex flex-col gap-16 px-6 pt-14 lg:gap-36 lg:px-0 lg:pt-0">
			<div className="relative z-0 flex-col lg:grid lg:min-h-screen lg:max-w-none lg:grid-cols-11 lg:px-0">
				<div className=" col-span-5 md:pr-3 lg:h-screen lg:py-3 ">
					<div className="mx-auto mt-16 rounded-xl bg-primary/10 shadow-md lg:mx-0 lg:mt-0 lg:h-full lg:w-full">
						<div className="lg:justfy-center relative h-full lg:flex lg:items-center">
							<div className="px-4 py-6 pt-10 lg:px-12 xl:px-24">
								<div className="lg-mt-8 flex max-w-xl flex-col gap-4 lg:mt-0 xl:gap-5">
									<span className="font-semibold text-primary">
										{t('privacy.section-title')}
									</span>
									<h1 className="text-h2 lg:text-h1 ">{t('privacy.title')}</h1>
									<div className="flex">
										<div className="self-cnter">
											<div className=""></div>
										</div>
									</div>
									<p className="text-lg">{t('privacy.text')}</p>
									<div className="mt-4 flex space-x-4">
										<a
											href="https://www.linkedin.com/company/onecarebiotech/"
											aria-label="OneCare Linkedin's page"
										>
											<Icon
												name="linkedin"
												className="cursor-pointer text-primary transition-colors duration-200 hover:text-secondary"
												size="lg"
											/>
										</a>
										<Link to="../contact">
											<Icon
												name="envelope-solid"
												className="cursor-pointer text-primary transition-colors duration-200 hover:text-secondary"
												size="lg"
											/>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-span-6">
					<div className=" lg:px-12 lg:pt-40  xl:px-24">
						<div className="mt-8 flex  flex-col gap-4 lg:mt-0 xl:gap-5">
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									1. {t('privacy.policies.0.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.0.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									2. {t('privacy.policies.1.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.1.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									3. {t('privacy.policies.2.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.2.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									4. {t('privacy.policies.3.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.3.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									5. {t('privacy.policies.4.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.4.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									6. {t('privacy.policies.5.title')}
								</h2>
								- {t('privacy.policies.5.text')}
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									7. {t('privacy.policies.6.title')}
								</h2>
								<Trans t={t}>{t('privacy.policies.6.text')}</Trans>
							</div>
							<div className="mt-4">
								<h2 className="mb-4 text-h5">
									8. {t('privacy.policies.7.title')}
								</h2>
								- {t('privacy.policies.7.text')}
							</div>
							<div className="mt-4">{t('privacy.text-1')}</div>
							<div className="mt-4">{t('privacy.text-2')}</div>
							<div className="mt-4">{t('privacy.updatedAt')}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
